/**
 * Formats a UTC datetime string to local time with a readable format
 * @param utcDateString - UTC datetime string (can be in various formats)
 * @returns Formatted local datetime string or "N/A" if invalid
 */
export const formatToLocalDateTime = (utcDateString: string | null): string => {
  if (!utcDateString) return "N/A";

  try {
    // Ensure the string is treated as UTC by appending 'Z' if not present
    let dateString = utcDateString.trim();
    if (
      !dateString.endsWith("Z") &&
      !dateString.includes("+") &&
      !dateString.includes("T")
    ) {
      // If it's in format like "2024-12-23 14:30:00", replace space with T and add Z
      dateString = dateString.replace(" ", "T") + "Z";
    } else if (
      !dateString.endsWith("Z") &&
      dateString.includes("T") &&
      !dateString.includes("+")
    ) {
      // If it has T but no timezone indicator, add Z
      dateString += "Z";
    }

    const date = new Date(dateString);

    // Verify the date is valid
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", utcDateString);
      return utcDateString;
    }

    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return utcDateString;
  }
};
